import { Injectable } from "@angular/core";
import { MockupHttpInterceptor } from "@vattenfall/core";

import { DirectSearchItem } from "./direct-search.model";

export const mockSearchHits = (title: string) =>
  new Array(5).fill(title).map<DirectSearchItem>((item, index) => ({
    title: `${item} ${index}`,
    url: "",
  }));

@Injectable()
export class DirectSearchServiceMockup extends MockupHttpInterceptor<DirectSearchItem> {
  constructor() {
    super({
      pathMatcher: "/api/search/direct-links",
      delay: 250,
      data: mockSearchHits("Direct link to search hit"),
    });
    super.onGet();
  }
}
